// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
// COMPONENTS
import { Fade } from 'react-awesome-reveal';
// ICONS
import { FiTool, FiPlay } from 'react-icons/fi';
import { RiChat1Line } from 'react-icons/ri';
import { HiOutlineMail } from 'react-icons/hi';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import CustomBlock from '../../components/CustomBlock';
import ContentBlock from '../../components/ContentBlock';
import ContentHeader from '../../components/ContentHeader';
import Button from '../../components/Button';
import FileUploadBlock from '../../components/FileUploadBlock';
// SERVICES AND HELPERS
import constants from '../../constants/constants'
import * as SalesToolService from '../../services/salestool.service';

const SalesToolDetailsPage = (props) => {
    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [salesToolId, setSalesToolId] = useState(parseInt(urlId) == urlId ? urlId : 0);

    const initialState = {
        id: salesToolId,
        name: "",
        description: "",
        videoPath: "",
        weeklySalesTalkingPoints: "",
        emailSubject: "",
        emailBody: ""
    };

    const [salesTool, setSalesTool] = useState(initialState);

    useEffect(() => {
        SalesToolService.Get(salesToolId)
            .then(res => {
                setSalesTool(res);
            })
            .catch(ex => { });
    }, []);

    return (
        <>
            <CustomBlock className="main-container light--bg">
                <Section>
                    <Fade
                        triggerOnce
                        direction="up"
                        duration={800}
                        delay={600}
                        className="height-fit-content w-100"

                    >
                        <CustomBlock className="content-container--card-style content">

                            <ContentHeader
                                title={salesTool.name}
                                headerSize="mdlg"
                                iconLeftClassName="lighter-blue--bg"
                                iconLeft={
                                    <FiTool className="darker-blue--clr" />
                                }
                            />

                            <CustomBlock className="content-block">
                                <p style={{whiteSpace: 'pre-line'}}>
                                    {salesTool.description}
                                </p>
                            </CustomBlock>

                        </CustomBlock>
                    </Fade>

                    <Fade
                        triggerOnce
                        direction="up"
                        duration={800}
                        delay={800}
                        className="height-fit-content w-100"
                    >
                        <CustomBlock className="content-container--card-style content" style={{ marginTop: 30 }}>
                            <ContentHeader
                                title="Sales Video"
                                headerSize="mdlg"
                                iconLeftClassName="lighter-red--bg"
                                iconLeft={
                                    <FiPlay className="danger--clr" size={25} style={{ marginLeft: 5 }} />
                                }
                            />
                            <ContentBlock cols={12}>
                                {
                                    salesTool.videoPath ?
                                        <FileUploadBlock
                                            videoUrl={`${constants.STORAGE_URL}${salesTool.videoPath}`}
                                        />
                                        : <></>
                                }
                            </ContentBlock>
                            {/* <CustomBlock className="content-block">
                                {
                                    salesTool.videoPath ?
                                        <FileUploadBlock
                                            videoUrl={`${constants.STORAGE_URL}${salesTool.videoPath}`}
                                        />
                                        : <></>
                                }
                            </CustomBlock> */}
                        </CustomBlock>
                    </Fade>

                    <Fade
                        triggerOnce
                        direction="up"
                        duration={800}
                        delay={900}
                        className="height-fit-content w-100"
                    >
                        <CustomBlock className="content-container--card-style content" style={{ marginTop: 30 }}>
                            <ContentHeader
                                title="Weekly Sales Talking Points"
                                headerSize="mdlg"
                                iconLeftClassName="lighter-green--bg"
                                iconLeft={
                                    <RiChat1Line className="success--clr" />
                                }
                            />

                            <CustomBlock className="content-block">
                                {parse(salesTool.weeklySalesTalkingPoints)}
                            </CustomBlock>
                        </CustomBlock>
                    </Fade>


                    <Fade
                        triggerOnce
                        direction="up"
                        duration={800}
                        delay={1000}
                        className="height-fit-content w-100"
                    >
                        <CustomBlock className="content-container--card-style content" style={{ marginTop: 30 }}>
                            <ContentHeader
                                title="Sales Email"
                                headerSize="mdlg"
                                iconLeftClassName="lighter-blue--bg"
                                iconLeft={
                                    <HiOutlineMail className="info--clr" />
                                }
                            />

                            <CustomBlock className="content-block">
                                <CustomBlock className="email-subject-block">
                                    <h3>
                                        {salesTool.emailSubject}
                                    </h3>
                                    <Button
                                        text="Copy Subject"
                                        className="info--bg"
                                        size="xs"
                                        onClick={() => navigator.clipboard.writeText(salesTool.emailSubject)}
                                    />
                                </CustomBlock>

                                <CustomBlock className="email-message-block">
                                    <CustomBlock>
                                        <p id="emailBody">
                                            {parse(salesTool.emailBody)}
                                        </p>
                                    </CustomBlock>
                                    <CustomBlock className="button-container">
                                        <Button
                                            text="Copy Message"
                                            className="info--bg"
                                            size="xs"
                                            onClick={() => {
                                                // special setup to copy the formatted text...
                                                var r = document.createRange();
                                                r.selectNode(document.getElementById("emailBody"));
                                                window.getSelection().removeAllRanges();
                                                window.getSelection().addRange(r);
                                                document.execCommand('copy');
                                                window.getSelection().removeAllRanges();
                                            }}
                                        />
                                    </CustomBlock>
                                </CustomBlock>
                            </CustomBlock>
                        </CustomBlock>
                    </Fade>
                </Section>
            </CustomBlock>
        </>
    );
}

export default SalesToolDetailsPage;